import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../modules/shared/services/auth.service';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(public router: Router, private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.auth.isAuthenticated()) {
      this.router.navigate([this.auth.getLandingPage()]);
      return false;
    }

    return true;
  }
}